// This icon file is generated automatically.
// tslint:disable
var FileFilled = { "name": "file", "theme": "filled", "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z" } }] } };
export default FileFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons-svg@4.0.0@@ant-design/icons-svg/es/asn/FileFilled.js
// module id = 1106
// module chunks = 0